/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { getAdmin } from "lib/v2/adminsApi";

export const ADMINS_ROUTES = {
  base: "/",
  new: "new",
  admin: ":id",
};

export const validateAdminRoute = async (params) => {
  const { id } = params;
  if (id === "new") {
    return {
      ok: true,
      status: 200,
    };
  }
  const req = await getAdmin(id);
  return req;
};
